import React, { useContext, useEffect, useState } from 'react';
import { Widgets } from '../Widgets/Widgets';
import { resizeMap } from '../../../../../../util/imageMaps';
import { FeedbackContext } from '../../../../../Feedback/FeedbackContext';
import debounce from 'lodash/debounce';
function Feedback() {
  const { handleOpenFeedbackModal } = useContext(FeedbackContext);

  useEffect(() => {
    setTimeout(() => {
      const doc = document;
      const feedbackButton = doc.getElementById('feedback-customer-service-button');
      if (feedbackButton) {
        feedbackButton.onclick = () => {
          handleOpenFeedbackModal();
        };
      }
    }, 1000);
  }, [handleOpenFeedbackModal]);
}

const debouncedResizeMap = debounce(resizeMap, 300);
const ContentTemplate = (props) => {
  const [fourProductCatalogEntryList, setFourProductCatalogEntryList] = useState(false);
  const [ContentRecommendation, setContentRecommendation] = useState(false);
  const [fourProductSlotNum, setFourProductSlotNum] = useState([]);
  const [contentSlotNum, setContentSlotNum] = useState([]);
  useEffect(() => {
    /**
     * If content contains a carousel with a useMap on first image, initialize the map.
     **/
    resizeMap();
    window.addEventListener('load', debouncedResizeMap);
    window.addEventListener('resize', debouncedResizeMap);
    try {
      if (props.layoutContent.slots != undefined) {
        var slotKeysToIterate = Object.keys(props.layoutContent.slots);
        for (var i = 0; i < slotKeysToIterate.length; i++) {
          var widgetKeysToIterate = props.layoutContent.slots[slotKeysToIterate[i]];

          if (
            widgetKeysToIterate.widgets != undefined &&
            widgetKeysToIterate.widgets.length > 0 &&
            widgetKeysToIterate.widgets[i] != undefined &&
            widgetKeysToIterate.widgets[i].widgetType != undefined &&
            widgetKeysToIterate.widgets[i].widgetType.length > 0
          ) {
            let widgetType = widgetKeysToIterate.widgets[i].widgetType;
            if (widgetType != undefined && widgetType === 'FourProductCatalogEntryList') {
              setFourProductCatalogEntryList(true);
              setFourProductSlotNum([...fourProductSlotNum, i]);
            }
          }

          if (
            widgetKeysToIterate.widgets != undefined &&
            widgetKeysToIterate.widgets.length > 0 &&
            widgetKeysToIterate.widgets[i] != undefined &&
            widgetKeysToIterate.widgets[i].widgetType != undefined &&
            widgetKeysToIterate.widgets[i].widgetType.length > 0 &&
            widgetKeysToIterate.widgets[i].content != undefined &&
            widgetKeysToIterate.widgets[i].content.length > 0
          ) {
            let widgetType = widgetKeysToIterate.widgets[i].widgetType;
            var content = widgetKeysToIterate.widgets[i].content;
            if (
              widgetType != undefined &&
              widgetType === 'ContentRecommendation' &&
              content != undefined &&
              content.indexOf('category-container') !== -1 &&
              content.indexOf('col-xs-12 col-sm-6 col-md-6 col-lg-3') !== -1
            ) {
              setContentRecommendation(true);
              setContentSlotNum([...contentSlotNum, i]);
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    return () => {
      window.removeEventListener('load', debouncedResizeMap);
      window.removeEventListener('resize', debouncedResizeMap);
    };
  }, [fourProductSlotNum, contentSlotNum]);

  return (
    <section id='ContentTemplate'>
      <Feedback />
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(0) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(0) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={1}
          slotData={props.layoutContent.slots['1']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(1) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(1) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={2}
          slotData={props.layoutContent.slots['2']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(2) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(2) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={3}
          slotData={props.layoutContent.slots['3']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(3) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(3) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={4}
          slotData={props.layoutContent.slots['4']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(4) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(4) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={5}
          slotData={props.layoutContent.slots['5']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(5) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(5) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={6}
          slotData={props.layoutContent.slots['6']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(6) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(6) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={7}
          slotData={props.layoutContent.slots['7']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
      <div
        className={`${
          (fourProductCatalogEntryList == true && fourProductSlotNum.indexOf(7) >= 0) ||
          (ContentRecommendation == true && contentSlotNum.indexOf(7) >= 0)
            ? 'row'
            : ''
        }`}
      >
        <Widgets
          slotNumber={8}
          slotData={props.layoutContent.slots['8']}
          passedAppFunctions={props.passedAppFunctions}
          contentData={props.contentData}
        />
      </div>
    </section>
  );
};

export { ContentTemplate };
